import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";

import { AdminAuthService } from "@/service/api/admin-auth";
import { SendFirstAccessCodeDto } from "@/service/dto/admin-auth";

const useSendFirstAccessCode = () => {
  return useMutation({
    mutationFn: async (data: SendFirstAccessCodeDto) => {
      try {
        await AdminAuthService.sendFirstAccessCode(data);
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 404) return;
        throw error;
      }
    },
    onSuccess: () => {
      toast.info("Se o e-mail informado estiver cadastrado, você receberá um novo código em instantes.", {
        toastId: "send_first_access_code",
      });
    },
    onError: () => {
      toast.error("Erro ao enviar o código de acesso. Tente novamente mais tarde.", { toastId: "send_first_access_code_error" });
    },
  });
};

export default useSendFirstAccessCode;
